var map = {
	"./PPII/sc.json": [
		2033,
		45
	],
	"./dataLeakage/sc.json": [
		2034,
		48
	],
	"./ransomware/sc.json": [
		2035,
		51
	],
	"./socialMedia/sc.json": [
		2036,
		54
	],
	"./whatsApp/sc.json": [
		2037,
		57
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 615;
module.exports = webpackAsyncContext;